
import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MonitoringService {
  private appInsights: ApplicationInsights;

  constructor() {
    if (environment.appInsightsConnectionString) {
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: environment.appInsightsConnectionString,
          enableAutoRouteTracking: true
        }
      });
      this.appInsights.loadAppInsights();
    }
  }

  trackException(
    exception: Error,
    properties?: { [key: string]: any },
    severityLevel?: number
  ): void {
    this.appInsights.trackException({ exception, properties, severityLevel });
  }
}
